/** @module FormulatedProduct/NewFoodSupplierItemMixin */
define([
	"dojo/_base/declare",
	"csi/locale",
	"Sourcing/NewSupplierItemMixin"
], function(declare,locale,NewSupplierItemMixin) {

	return declare(NewSupplierItemMixin, {

		createQuotes: function(/*Function*/creator) {
			// summary: create SupplierItems according to form
			const factory =  locale.resource("Factory");
			const field = this.isSupplierFactory ? this.m_formData.getField(factory) : this.m_formData.getField("Supplier");
			if (this.sources && !_.isArray(this.sources)) {
				this.sources = [this.sources];
			}

			if (!this.isSupplierFactory) {
				this.srcUrlNames = this._getSupplierNames(field, this.sources);
			}

			const self = this;

			var items = _.map(this.srcUrlNames, function(value, key) {
				return self.createSupplierItems(self.m_writer, self.m_formData, creator, key, value);
			});

			return _.flatten(items); 
		},
	});
});
